import { ChevronDown } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useCallback, useState } from "react";
import { Info, Target, Users } from "lucide-react";

const AboutUsDropdown = ({ isMobile = false, setToggle }) => {
  const [isOpen, setIsOpen] = useState(false);


  const handleScrollToTeam = useCallback(() => {

    if (window.location.pathname === "/about-us") {
      const el = document.getElementById("team");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      
      window.location.href = "/about-us#team";
    }
  }, []);

  return (
    <div
      className={` ${!isMobile
        ? "relative inline-block "
        : "p-0 m-0  flex flex-col items-start "
        } text-left`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        className={`p-0 gap-1 items-center font-medium navlink-styles transition-all ${!isMobile ? "inline-flex relative" : "flex "
          } ${window.location.pathname === "/about-us"
            ? "text-gold font-semibold"
            : "text-white font-medium"
          }`}
      >
        <span className="flex gap-4">
          {isMobile && <Info size={20} className="navlink-icon m-0 p-0" />}
          About Us
        </span>
        <ChevronDown size={15} />
      </button>
      {isMobile ? (
        <div
          className={` mt-2 z-10 right-1 w-40 text-nowrap h-auto rounded-md shadow-lg  text-white ring-1 ring-black ring-opacity-5 transition-all duration-300 ease-in-out overflow-hidden ${isOpen
            ? "opacity-100 scale-100 max-h-44"
            : "opacity-0 scale-95 max-h-0"
            }`}
        >
          <div className="py-3 px-4 flex flex-col gap-2">
            <Link
              to="/about-us#mission-vision"
              onClick={() => {
                setIsOpen(false);
                setToggle(false);
              }}
              className="text-white-100 font-medium hover:bg-black/10 py-1 rounded-md px-4 transition-all duration-200 ease-in-out hover:translate-x-1 navlink-styles flex gap-4 navlink-styles2"
            >
              <Target size={20} className="navlink-icon" />
              Mission
            </Link>

            <Link
              to="/about-us#team"
              onClick={(e) => {
                e.preventDefault();
                setIsOpen(false);
                setToggle(false);
                handleScrollToTeam();
              }}
              className="text-white-1000 font-medium hover:bg-black/10 py-1 rounded-md px-4 text-[9px] transition-all duration-200 ease-in-out hover:translate-x-1 navlink-styles flex gap-4 navlink-styles2"
            >
              <Users size={20} className="navlink-icon" /> Team
            </Link>
          </div>
        </div>
      ) : (
        <div
          className={`absolute mt-2 z-10 right-1 w-40 text-nowrap h-auto rounded-md shadow-lg border border-slate-600 bg-slate-300 text-slate-900 ring-1 ring-black ring-opacity-5 transition-all duration-300 ease-in-out overflow-hidden ${isOpen
            ? "opacity-100 scale-100 max-h-44"
            : "opacity-0 scale-95 max-h-0"
            }`}
        >
          <div className="py-3 px-4 flex flex-col gap-2">
            <Link
              to="/about-us#mission-vision"
              onClick={() => {
                setIsOpen(false);
                setToggle(false);
              }}
              className="text-slate-900 font-medium hover:bg-black/10 py-1 rounded-md px-4 text-base transition-all duration-200 ease-in-out hover:translate-x-1"
            >
              Mission
            </Link>

            <Link

              to="/about-us#team"
              onClick={(e) => {
                e.preventDefault();
                setIsOpen(false);
                // setToggle(false);
                handleScrollToTeam();
              }}
              className="text-slate-900 font-medium hover:bg-black/10 py-1 rounded-md px-4 text-base transition-all duration-200 ease-in-out hover:translate-x-1"
            >
              Team
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutUsDropdown;
